module.exports = __webpack_public_path__ + "static/media/page_background_sec_mobile2.c491ccb3.svg";